import { z } from "zod";

const TpvBarcodeDetailsSchema = z
  .object({
    barcode_base64: z.string(),
    qrcode_base64: z.string(),
    track_code: z.string(),
  })
  .transform((api) => ({
    barcode: api.barcode_base64,
    qr: api.qrcode_base64,
    trackCode: api.track_code,
  }));

type TpvBarcodeDetails = z.infer<typeof TpvBarcodeDetailsSchema>;

export { TpvBarcodeDetailsSchema, type TpvBarcodeDetails };
